import React from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandSeparator,
  CommandShortcut,
} from "@/components/ui/command";

/**
 * Global Command-K palette. Navigation targets come from the same
 * permission-aware nav groups the sidebar uses, so nothing a user cannot
 * access is ever exposed here.
 */
export default function CommandPalette({ open, onOpenChange, groups = [], quickActions = [] }) {
  const navigate = useNavigate();

  const go = (to) => {
    onOpenChange(false);
    if (to) navigate(to);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search pages, actions, modules…" data-testid="command-input" />
      <CommandList>
        <CommandEmpty>No matches found.</CommandEmpty>

        {quickActions.length > 0 && (
          <>
            <CommandGroup heading="Quick actions">
              {quickActions.map((a) => (
                <CommandItem
                  key={`qa-${a.to}-${a.label}`}
                  value={`action ${a.label} ${a.to}`}
                  onSelect={() => go(a.to)}
                  data-testid={`command-action-${a.label.replace(/\s+/g, "-").toLowerCase()}`}
                >
                  {a.icon ? <a.icon /> : null}
                  <span>{a.label}</span>
                  <CommandShortcut>Go</CommandShortcut>
                </CommandItem>
              ))}
            </CommandGroup>
            <CommandSeparator />
          </>
        )}

        {groups.map((group) => (
          <CommandGroup key={group.id} heading={group.label}>
            {group.items.map((item) => (
              <CommandItem
                key={item.to}
                value={`${group.label} ${item.label} ${item.to}`}
                onSelect={() => go(item.to)}
                data-testid={`command-nav-${item.label.replace(/\s+/g, "-").toLowerCase()}`}
              >
                {item.icon ? <item.icon /> : null}
                <span>{item.label}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
}
